function Booking({ currentLang }) {
  const headings = { en: "Reserve a Session", gr: "Κράτηση Μαθήματος", it: "Prenota una Lezione" };
  return (
    <div className="row justify-content-center">
      <div className="col-lg-10 col-md-12 mb-3">
        <h2 className="mb-4 text-center">{headings[currentLang]}</h2>                
        <div style={{ position: 'relative', height: '65vh', overflow: 'hidden', borderRadius: '16px', border: '1px solid #eae7e2', boxShadow: '0 8px 30px rgba(0,0,0,0.02)' }}> 
          <iframe 
            src="https://app.formbricks.com/s/cmh9fmwn235dgad01lyfbds0w?embed=true" 
            title="Scheduler"
            frameBorder="0" 
            style={{ position: 'absolute', left: '0', top: '0', width: '100%', height: '100%', border: '0' }}
          />
        </div>
      </div>
    </div>
  );
}

export default Booking;